<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <!-- <div class="col-sm-12"> -->
                <div class="col">
                  <h3 class="page-title">Applications</h3>
                  <ul class="breadcrumb">
                    <li class="breadcrumb-item active">Applications</li>
                    <li class="breadcrumb-item active" v-if="displayStatus === 10">All</li>
                    <li class="breadcrumb-item active" v-if="displayStatus === 0">New</li>
                    <li class="breadcrumb-item active" v-else-if="displayStatus === 2">Test</li>
                    <li class="breadcrumb-item active" v-else-if="displayStatus === 3">Interview Scheduling</li>
                    <li class="breadcrumb-item active" v-else-if="displayStatus === 4">Interview</li>
                    <li class="breadcrumb-item active" v-else-if="displayStatus === 5">Negotiation</li>
                    <li class="breadcrumb-item active" v-else-if="displayStatus === 6">Medical</li>
                    <li class="breadcrumb-item active" v-else-if="displayStatus === 1">Accepted</li>
                    <li class="breadcrumb-item active" v-else-if="displayStatus === 8">Rejected</li>
                  </ul>
                </div>
                <div class="col-md-1 float-right ml-auto">         
                <div class="row">
                  <button class="btn btn-primary dropdown-toggle m-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Status
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" @click="getAllApplications">All</a>
                    <a class="dropdown-item" @click="getNewApplications">Shortlisted</a>
                    <a class="dropdown-item" @click="getRelatedApplications">Related</a>
                    <a class="dropdown-item" @click="getAcceptedApplications">Accepted</a>
                    <a class="dropdown-item" @click="getPhoneApplications">Interview Scheduling</a>
                    <a class="dropdown-item" @click="getAptitudeApplications">Test</a>
                    <a class="dropdown-item" @click="getFaceToFaceApplications">Interview</a>
                    <a class="dropdown-item" @click="getNegotiationApplications">Negotiation</a>
                    <!-- <a class="dropdown-item" @click="getMedicalApplications">Medical</a> -->
                    <a class="dropdown-item" @click="getRejectedApplications">Rejected</a>
                  </div>
                </div>
                
              </div>
              <div class="col-md-4 float-right ml-auto"> 
                  <button class="btn btn-secondary m-1" type="button" @click="openImportDialog" v-if="bothExist > 0">
                    Import Test Scores
                  </button>
                  <button class="btn btn-secondary m-1" type="button" @click="openMessageDialog" v-if="newExist > 0">
                    Send Screening Assignment
                  </button>
                </div>
              <!-- </div> -->
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <v-data-table
                      :headers="headers"
                      :items="applications"
                      sort-by=""
                      class="elevation-1"
                    >
                  <template v-slot:[`item.profile`]="{ item }">
                      <router-link :to="`/applications/${item.id}`">
                              <span>{{item.applicant.firstName + ' ' + item.applicant.lastName}}</span></router-link
                            >
                  </template>
                  <template v-slot:[`item.vacant`]="{ item }">
                      <router-link :to="`/vacancies/vid${item.vacancy.id}`">
                              <span
                                >{{item.vacancy.jobProfile.title}}</span
                              ></router-link
                            >
                  </template>
                  <template v-slot:[`item.apt`]="{ item }">
                        {{(!item.applicationScore) ? 'Not yet' : (item.applicationScore && item.status > 2) ? 'Passed' : 'Failed'}}
                  </template>
                  <template v-slot:[`item.expected`]="{ item }">
                        ₦{{item.expectedSalary.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}
                  </template>
                  <template v-slot:[`item.created`]="{ item }">
                        {{ item.createdAt ? new Date(item.createdAt).toLocaleDateString() : ""}}
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 0"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-purple"></i> Shortlisted
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 1"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-success"></i> Accepted
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 7"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-success"></i> Related
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 2"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Test 
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 3"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Interview Scheduling
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 4"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Interview 
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 5"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Negotiation
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 6"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Medical
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 8"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-danger"></i> Rejected 
                          </a>
                  </template>
                </v-data-table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Delete Employee Modal -->
                <v-dialog v-model="dialogImport" max-width="725px">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Import Test Score</h5>
                                <button type="button" class="close" aria-label="Close" @click="closeImport">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="error">
								                            <strong>Error!</strong> {{error}}
								                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
									                            <span aria-hidden="true">&times;</span>
								                            </button>
							                            </div>
                                                    </div>
                                                </div> 
                                <div class="form-header">
                                    <h3>Import Test Score</h3>
                                    <p>Download an excel template by clicking on the below button</p>
                                    <br />
                                    
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                    <p>Note: please do not change the layout of the cells in the excel, you are expected to update score only. <br>
                                    </p>
                                    <br/>
                                    </div>
                                    <div class="col-12">
                                            <a 
                                            @click="downloadTemplate"
                                            class="btn btn-primary continue-btn"
                                            data-dismiss="modal">
                                            Download Template</a>
                                    </div>
                                </div>
                                <hr>
                                <hr>
                                <div class="row">
                                    <div class="col-sm-12" v-if="vacancy.vacancysettings">
                                        <div class="form-group" v-if="vacancy.vacancysettings.passAverageScore > 0">
                                            <label>Upload File</label>
                                            <div class="custom-file">
                                                <input type="file" name="file" class="form-control" id="cv_upload" @change="onFilePicked">
                                            </div>   
                            
                                        </div>
                                        <span class="text-danger" v-else>Note: please set the pass score for this job by clicking on vacancy menu, edit the vacancy and put the pass score under test section. </span>

                                    </div>
                                    <div class="col-sm-3" v-if="vacancy.vacancysettings.passAverageScore > 0">
                                        <a 
                                            @click="importScore"
                                            v-if="file"
                                            class="btn btn-primary continue-btn"
                                            data-dismiss="modal">
                                            Import</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                </v-dialog>
                <!-- /Delete Employee Modal -->

                <v-dialog v-model="messageDialog" max-width="725px">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Send Screening Assignment</h5>
                                <button type="button" class="close" aria-label="Close" @click="closeMesssage">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onSendTestMessage">
                              <div class="form-group">
                                  <label class="col-form-label">Message Title <span class="text-danger">*</span></label>
                                  <input type="text" v-model="messageTitle" id="name" name="name" class="form-control" />
                                                
                              </div>
                              <quill-editor
                                v-model="messageBody"
                                ref="myQuillEditor"
                                :options="editorOption">
                              </quill-editor>
                              <div class="submit-section">
                                        <button class="btn btn-primary submit-btn" type="submit">Submit</button>
                                    </div>
                              </form>
                            </div>
                        </div>
                </v-dialog>
          </div>
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { jobService } from '@/services/jobService';
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data () {
    return {
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'profile',
        },
        { text: 'Vacancy', value: 'vacant' },
        { text: 'Status Reason', value: 'stat' },
        { text: 'Test', value: 'apt' },
        { text: 'Expected Salary', value: 'expected' },
        { text: 'Received On', value: 'created' },
      ],
      dialogImport: false,
      messageDialog: false,
      id: this.$route.params.id,
      messageTitle: "Screening Test",
      messageBody: "<p>Add the message</p>",
      displayStatus: 10,
      newExist: -1,
      bothExist: -1,
      applications: [],
      allapplications: [],
      newapplications: [],
      phoneapplications: [],
      aptitudeapplications: [],
      facetofaceapplications: [],
      negotiationapplications: [],
      acceptedapplications: [],
      rejectedapplications: [],
      vacancy: {
        vacancysettings: {}
      },
      company: authenticationService.currentOfficeValue,
      file: null,
      fileName: '',
      error: '',
      editorOption: {
        theme: 'snow',
    boundary: document.body,
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }]
      ]
    },
    placeholder: 'Insert text here ...',
    readOnly: false
      },
    }
  },
  mounted() {
    this.getVacancy()
    this.getAllApplications()
    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
  },
  methods: {
    openImportDialog() {
        this.dialogImport = true;
    },
    closeImport() {
      this.dialogImport = false;
    },
    openMessageDialog() {
        this.messageDialog = true;
    },
    closeMesssage() {
      this.messageDialog = false;
    },
    getAllApplications() {
      jobService.getAllApplicationsByVacancy(this.id)
      .then(
        p => {
          this.applications = p;
          this.bothExist = p.findIndex(a => a.status == 0 || a.status == 2)
          this.newExist = p.findIndex(a => a.status == 0)
          console.log(p)
          this.displayStatus = 10;
        }
      )
    },
    getVacancy(){
      jobService.getVancancyById(this.id)
        .then(
          a => {
            console.log(a)
            this.vacancy = a;
          }
        )
    },
    onFilePicked(event) {
      			const files = event.target.files
      			this.fileName = files[0].name
				  // console.log(this.fileName)
      			this.file = files[0];
			},
    getNewApplications() {
      jobService.getAllApplicationsByVacancy(this.id)
        .then(
          p => {
            this.newapplications = p.filter(a => a.status === 0)
            this.newExist = p.findIndex(a => a.status == 0)
            this.bothExist = -1
            console.log(this.newapplications)
            this.applications = this.newapplications;
            this.displayStatus = 0;
          }
        )
    },
    getRelatedApplications() {
      jobService.getAllApplicationsByVacancy(this.id)
        .then(
          p => {
            this.newapplications = p.filter(a => a.status === 6)
            console.log(this.newapplications)
            this.newExist = -1
            this.bothExist = -1
            this.applications = this.newapplications;
            this.displayStatus = 6;
          }
        )
    },
    getAcceptedApplications() {
      jobService.getAllApplicationsByVacancy(this.id)
        .then(
          p => {
            this.acceptedapplications = p.filter(a => a.status === 1)
            console.log(this.applications)
            this.newExist = -1
            this.bothExist - 1
            this.applications = this.acceptedapplications;
            this.displayStatus = 1;
          }
        )
    },
    getPhoneApplications() {
      jobService.getAllApplicationsByVacancy(this.id)
        .then(
          p => {
            this.phoneapplications = p.filter(a => a.status === 2)
            this.bothExist = p.findIndex(a => a.status == 0 || a.status == 2)
            this.newExist = -1
            console.log(this.phoneapplications)
            this.applications = this.phoneapplications;
            this.displayStatus = 3;
          }
        )
    },
    getAptitudeApplications() {
      jobService.getAllApplicationsByVacancy(this.id)
        .then(
          p => {
            this.aptitudeapplications = p.filter(a => a.status === 3)
            this.newExist = -1
            this.bothExist = -1
           console.log(this.aptitudeapplications)
            this.applications = this.aptitudeapplications;
            this.displayStatus = 2;
          }
        )
    },
    getFaceToFaceApplications() {
      jobService.getAllApplicationsByVacancy(this.id)
        .then(
          p => {
            this.facetofaceapplications = p.filter(a => a.status === 4)
            this.newExist = -1
            this.bothExist = -1
            // console.log(this.inactiveapplications)
            this.applications = this.facetofaceapplications;
            this.displayStatus = 4;
          }
        )
    },
    getNegotiationApplications() {
      jobService.getAllApplicationsByVacancy(this.id)
        .then(
          p => {
            this.negotiationapplications = p.filter(a => a.status === 5)
            this.newExist = -1
            this.bothExist = -1
            // console.log(this.negotiationapplications)
            this.applications = this.negotiationapplications;
            this.displayStatus = 5;
          }
        )
    },
    getRejectedApplications() {
      jobService.getRejectedApplicationsByVacancy(this.id)
        .then(
          p => {
            this.rejectedapplications = p
            this.newExist = -1
            this.bothExist = -1
            this.applications = this.rejectedapplications;
            this.displayStatus = 8;
          }
        )
    },
    importScore() {
      jobService.importApplicationScore(this.company.id, this.file)
        .then(
          x => {
            this.closeImport()
           jobService.getAllApplicationsByVacancy(this.id)
      .then(
        p => {
          this.applications = p;
          this.bothExist = p.findIndex(a => a.status == 0 || a.status == 2)
          this.newExist = p.findIndex(a => a.status == 0)
          console.log(p)
          this.displayStatus = 10;
        }
      )
          }
        )
    },
    onSendTestMessage (){
      jobService.sendTestMessage(this.id, this.messageTitle, this.messageBody)
        .then(
          p => {
            this.closeMesssage()
            jobService.getAllApplicationsByVacancy(this.id)
              .then(
                p => {
                  this.bothExist = p.findIndex(a => a.status == 0 || a.status == 2)
                  this.newExist = -1
                  // console.log(this.negotiationapplications)
                  this.applications = p;
                  this.displayStatus = 10;
                }
              )
          }
        )
    },
    downloadTemplate () {
          jobService.downloadNewTestApplicationTemplate(this.id)
            .then(
                response => {
                    let blob = new Blob([response.data], { type: response.data.type });
                    // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, response.fileName);
                    } else {
                        var downloadElement = document.createElement("a");
                        var href = window.URL.createObjectURL(blob); // Create a download link
                        downloadElement.href = href;
                        downloadElement.download = response.fileName; // Download the file name
                        document.body.appendChild(downloadElement);
                        downloadElement.click(); // click to download
                        document.body.removeChild(downloadElement); // Download complete removal element
                        window.URL.revokeObjectURL(href); // Release Blob object
                    }
                }
            )
    
    },
    
  },
  name: "applications"
};
</script>



// WEBPACK FOOTER //
// src/components/applications/main.vue